import styled from 'styled-components';

import SvgIcon from '@components/svg-icon/svg-icon';

import { flexbox, flexDirection } from '@styles/helpers/flexbox';
import { widthFillAvailable } from '@styles/helpers/common/index';

import ThemeHelper from '@themes/theme-helper';

export const Icon = styled(SvgIcon)`
  width: auto;
`;

export const Root = styled.div(props => {
  const { typography, colours } = ThemeHelper.getTheme(props);

  return `
      ${flexbox()}
      ${flexDirection('column')}
      ${widthFillAvailable()}

      font-family: ${typography.family};
      font-size: 14px;
  
      svg {
        margin-top: 20px;
        width: 50px;
        height: 50px;
        path {
          fill: ${colours.grey[400]};
        }
      }
  `;
});

export const Paragraph = styled.p`
  margin: 0 auto;
  width: auto;

  :nth-of-type(2) {
    width: 40%;
    margin-top: 20px;
  }
`;
